export * from './machine-vnc-template';
